import { handleActions } from 'redux-actions';

import demoChannel from 'shared/constants/demo-channel';

import { NAME as APP_SETTINGS_UPDATE } from 'widget/redux/client/actions/app-settings/update';
import { NAMES as CHANNEL_GET } from 'shared/redux/server/actions/channel/get';


export default handleActions({
  [APP_SETTINGS_UPDATE]: (state, { payload }) => {
    if (!payload.fonts) {
      return state;
    }
    return _.get(payload, 'fonts.channelId') || state || demoChannel.id;
  },
  [CHANNEL_GET.FAIL]: (state, { payload }) => {
    if (_.get(payload, 'response.error.code') === -7710) {
      return demoChannel.id;
    }

    return state;
  },
}, null);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/current-channel-id.js